import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
export const GET_ASSOCIATION_DEFINITION = 'campaignsPlatformComponentsAssociationDefinition';
const QUERY_ASSOCIATION_DEFINITION = registerQuery({
  fieldName: GET_ASSOCIATION_DEFINITION,
  args: ['associationId', 'associationCategory'],
  fetcher({
    associationId,
    associationCategory
  }) {
    return http.post('associations/v1/definitions/batch', {
      data: [{
        associationCategory,
        associationTypeId: associationId
      }]
    }).then(res => {
      if (res.length) {
        return res[0];
      }
      return undefined;
    });
  }
});
export const useFetchAssociationDefinition = ({
  associationSettings,
  objectType
}) => {
  var _associationSettings$, _metadata$association, _metadata$isCustomObj;
  const metadata = associationSettings === null || associationSettings === void 0 || (_associationSettings$ = associationSettings[objectType]) === null || _associationSettings$ === void 0 || (_associationSettings$ = _associationSettings$.campaignsAssociations) === null || _associationSettings$ === void 0 ? void 0 : _associationSettings$.metadata;
  const associationIdFromSettings = metadata === null || metadata === void 0 || (_metadata$association = metadata.associationId) === null || _metadata$association === void 0 ? void 0 : _metadata$association.value;
  const associationCategory = (metadata === null || metadata === void 0 || (_metadata$isCustomObj = metadata.isCustomObject) === null || _metadata$isCustomObj === void 0 ? void 0 : _metadata$isCustomObj.value) === true ? 'USER_DEFINED' : 'HUBSPOT_DEFINED';
  const {
    data,
    loading,
    error
  } = useQuery(QUERY_ASSOCIATION_DEFINITION, {
    variables: {
      associationId: associationIdFromSettings,
      associationCategory
    },
    skip: !associationIdFromSettings
  });
  return {
    data: data === null || data === void 0 ? void 0 : data[GET_ASSOCIATION_DEFINITION],
    loading,
    error
  };
};